<template>
  <div
    id="svg"
    :class="['svg-container', color]"
    v-html="image || imageRef"
  ></div>
</template>

<script lang="ts">
import { useImageCacheStore } from "@/store/images";
import { getSvg } from "@/utils/generics.util";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "MagicSvg",
  props: {
    path: {
      type: String,
      required: true,
    },
    color: {
      type: String,
    },
    image: {
      type: String,
    },
  },
  setup(props) {
    const imageRef = ref("");

    const store = useImageCacheStore;

    async function getImage() {
      const cachedImage = store.getImage(props.path!);
      if (cachedImage) {
        imageRef.value = cachedImage;
        return;
      }

      const image = await getSvg(`/images/${props.path}`);
      imageRef.value = image;
      store.setImage(props.path!, image);
    }

    onMounted(() => getImage());

    return { imageRef };
  },
});
</script>

<style lang="scss">
.svg-container {
  svg {
    fill: currentColor;
    circle,
    rect {
      fill: currentColor;
      stroke: currentColor;
    }
  }
}
</style>
